import React, { useEffect, useState } from 'react'
import SvgIcon from '../SVGIcon/SvgIcon'
import { cls } from '../../utils/utils'
import { IScrollToTopButton } from './ScrollToTopButton.types'
import styles from './ScrollToTopButton.module.scss'

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

const ScrollToTopButton: React.FC<IScrollToTopButton> = () => {
  const [isVisible, setVisibility] = useState(false)

  const setOffset = () => {
    setVisibility(window.pageYOffset > 500)
  }

  useEffect(() => {
    addEventListener('scroll', setOffset)

    return () => {
      removeEventListener('scroll', setOffset)
    }
  }, [])

  return (
    <button className={cls(styles.scrollBtn, isVisible ? styles.show : '')} onClick={scrollToTop}>
      <SvgIcon href={'/images/icons/scroll-to-top.svg#icon'} className={styles.arrow} />
    </button>
  )
}

export default ScrollToTopButton
